import classNames from 'classnames'
import React from 'react'

const Email = (injectedStyle = '') => ({ children }) => (
  <a href={"mailto:" + children} className={classNames(injectedStyle)}>{children}</a>
)

export default Email
